import './MenuHeader.scss';

export default function MenuHeader({ title, description }) {
  console.log('description', description);
  return (
    <>
      {' '}
      {description || title ? (
        <div className="common-header menu-header">
          <h3
            className={description ? 'menu-title' : 'menu-title2'}
            style={description ? { textDecoration: 'none' }:{}}>
            {title}
          </h3>
          {description && <p className="menu-description">{description}</p>}
        </div>
      ) : (
        ''
      )}
    </>
  );
}
